import { render, staticRenderFns } from "./addNameAuthentication.vue?vue&type=template&id=618a62b8&"
import script from "./addNameAuthentication.vue?vue&type=script&lang=js&"
export * from "./addNameAuthentication.vue?vue&type=script&lang=js&"
import style0 from "./addNameAuthentication.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\sdk_manage_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('618a62b8')) {
      api.createRecord('618a62b8', component.options)
    } else {
      api.reload('618a62b8', component.options)
    }
    module.hot.accept("./addNameAuthentication.vue?vue&type=template&id=618a62b8&", function () {
      api.rerender('618a62b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/authentication/components/addNameAuthentication.vue"
export default component.exports